import { render, staticRenderFns } from "./activeCourseAssignmentCheck.html?vue&type=template&id=12693aba&scoped=true&external"
import script from "./activeCourseAssignmentCheck.vue?vue&type=script&lang=js"
export * from "./activeCourseAssignmentCheck.vue?vue&type=script&lang=js"
import style0 from "./activeCourseAssignmentCheck.css?vue&type=style&index=0&id=12693aba&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12693aba",
  null
  
)

export default component.exports